import { useEffect, useState } from "react";
import styles from "./CircularProgress.module.css"
import { Each } from "../common/Each";

const CircularProgress = ({ data, content = { style: {} } }) => {
    const gap = 5
    const [displayData, setDisplayData] = useState([]);
    const [percentage, setPercentage] = useState(0)
    const totalLength = 100;
    const formattedPercentage = new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
    }).format(Number(percentage || 0));

    useEffect(() => {
        const sum = data.map(d => d.value).reduce((acc, curr) => acc + curr, 0);
        setPercentage(sum);
        let filled = [...data];
        if (sum < 100) {
            filled.push({ value: 100 - sum, color: '#E1E6EE' });
        }
        setDisplayData(filled);
    }, [data]);

    return (
        <div className={styles.container}>
            <svg
                width="240"
                height="240"
                viewBox="0 0 240 240"
                className={styles.circle}
                style={{ transform: 'rotate(90deg)' }}
            >
                <Each
                    of={displayData}
                    render={(d, index) => {
                        // Calcola l'offset come la somma dei valori precedenti
                        const prevSum = displayData.slice(0, index).reduce((acc, curr) => acc + curr.value, 0);
                        const value = d.value - gap;
                        return <circle
                            key={index}
                            cx="120"
                            cy="120"
                            r="100"
                            fill="none"
                            strokeLinecap="round"
                            stroke={d.color}
                            strokeWidth="25"
                            pathLength={totalLength}
                            strokeDasharray={`${value} ${totalLength - value}`}
                            strokeDashoffset={-prevSum}
                        />
                    }}
                />
                <text x="50%" y="50%" textAnchor="middle" dy=".3em"
                    fontSize="40"
                    fontFamily="Urbane Rounded"
                    fontWeight="800"
                    fill="#2A2A2A" transform="rotate(-90, 120, 120)"
                    {...content?.style ?? {}}
                >
                    {content?.label}

                    {!content?.label && `${formattedPercentage}%`}
                </text>
                {content?.sublabel &&
                    <text x="50%" y="62.5%" textAnchor="middle" dy=".3em"
                        fontSize="14"
                        fontFamily="Urbane Rounded"
                        fontWeight="800"
                        fill="rgba(var(--text-color-rgb), 40%)" transform="rotate(-90, 120, 120)"
                    >
                        {content.sublabel}
                    </text>
                }
            </svg>
        </div>
    );
};

export default CircularProgress;
